import React from 'react';
import TextField from 'shared/components/text-field/TextField'

class ExerciseItem extends React.Component {
  render() {
    let { title, desc, setIndex, exercise, seriesReps } = this.props;
    return (
      <div className="exercise-item">
        <div className="exercise-head">
          <h4>{title}</h4>
          <p>{desc}</p>
        </div>
        <div className="exercise-input">
          <div>
            <TextField
              type="number"
              name={`currentSets[${setIndex}].${exercise.id}.weight`}
              placeholder="  - -  "
              hideLabel={true}
            />
            <label>Weight <span>kg</span></label>
          </div>
          <div>
            <TextField
              type="number"
              name={`currentSets[${setIndex}].${exercise.id}.reps`}
              placeholder="  - -  "
              hideLabel={true}
            />
            <label>Reps <span>{seriesReps}</span></label>
          </div>
        </div>
      </div>
    );
  }
}

export default ExerciseItem;
